import { Navigate } from 'react-router-dom';
import React, { Fragment } from 'react';
import { Spinner } from 'app/components/ui/spinner';
import { useUser } from 'app/shared/contexts/user';
import { useApi } from 'app/shared/contexts/api';
import { useOpenParams } from 'app/shared/hooks/use-open-params';

interface PrivateProps {
  redirectTo?: string;
  children: React.ReactNode;
}
export const Private = ({ redirectTo = '/error', children }: PrivateProps): JSX.Element | null => {
  const { user, isLoading } = useUser();
  const authToken = useApi('authToken');
  const { buildingUuid } = useOpenParams();

  if (isLoading) {
    return (
      <div className="flex flex-col justify-center h-screen">
        <Spinner />
      </div>
    );
  }

  // The building comes from the launch params; without one there is no feed to render. This guard used
  // to live in AppRoot, which existed only to read it and redirect.
  if (!authToken || !buildingUuid || (!isLoading && !user)) {
    return <Navigate to={redirectTo} />;
  }

  // Wrapped in a React Fragment intentionally
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <Fragment>{children}</Fragment>;
};
